import React from 'react';
import { Box } from '@mui/material';

interface GridItem {
    id: number;
}

export default function AvailableTeachersCardGrid<T extends GridItem>({
    renderItem,
    items,
    width,
}: {
    width?: string;
    renderItem: (item: T) => React.ReactNode;
    items: T[];
}) {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: '1fr',
                    md: '1fr',
                    lg: 'repeat(2, 1fr)',
                    xl: 'repeat(3, 1fr)',
                },
                gap: '20px',
                width: 'fit-content',
                maxWidth: '100%',
                mx: 'auto',
                justifyItems: 'start',
                '& > *': {
                    justifySelf: 'start',
                    width: width || '350px',
                },
            }}
        >
            {items.map((item) => (
                <Box sx={{ width: '100%', maxWidth: width || '350px' }} key={item.id}>
                    {renderItem(item)}
                </Box>
            ))}
        </Box>
    );
}
